module.exports = __webpack_public_path__ + "media/images/companyPage/empathy-26b4c961034aae1f750fd89e3e1e4cb9.svg";